/**
 * @name generateTableHead
 * @param access {Object} - Доступы для таблицы
 */
export const generateTableHead = (access) => [
  access?.delete && { title: 'All' },
  { title: 'Service' },
  { title: 'Date' },
  { title: 'Update' },
  access?.delete && { title: 'Delete' },
].filter(Boolean);

/**
 * @name generateTableBody
 * @param item {Object} - Элемент для таблицы
 * @param access {Object} - Доступы для элемента таблицы
 */
export const generateTableBody = (item, access) => [
  { value: '', type: 'checkbox', access: access?.delete },
  { value: item.service, type: 'service', access: true },
  { value: item.date, type: 'data', access: true },
  { value: item.type, type: 'update', access: true },
  { value: '', type: 'delete', access: access?.delete },
].filter((item) => item.access);

/**
 * @name prepareConfirmBtnsText
 */
export const prepareConfirmBtnsText = () => ({
  confirmBtnText: 'Delete',
  cancelBtnText: 'Cancel',
  submitStyle: 'primary',
});
